import { BrokerId, FrontendLoad } from '@trucksmarter/shared';
import { DallasTableDataCell } from '~/app/_ui/Dallas/Table/DallasTable';
import LoadTableStopListHovercardAnchor from './LoadTableHoverableStopListAnchor/LoadTableStopListHovercardAnchor';

type Props = {
  className?: string;
  load: FrontendLoad;
  brokerId: BrokerId;
  children: React.ReactNode;
};

export default function StopListHovercardAnchorCell({
  className,
  load,
  brokerId,
  children,
}: Props) {
  return (
    <DallasTableDataCell className={className}>
      <LoadTableStopListHovercardAnchor stops={load.stops} brokerId={brokerId}>
        {children}
      </LoadTableStopListHovercardAnchor>
    </DallasTableDataCell>
  );
}
